import { Directive, Injector, OnInit, TemplateRef, ViewContainerRef, effect, input, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { User } from '../models/auth.model';
import { AccessRoleEnum } from '../models/framework.model';
import { AuthService } from '../services/auth.service';

@UntilDestroy()
@Directive({ selector: '[acadvRequireRole]' })
export class RequireRoleDirective implements OnInit {
  private templateRef = inject<TemplateRef<void>>(TemplateRef);
  private vcr = inject(ViewContainerRef);
  private authService = inject(AuthService);
  private injector = inject(Injector);

  readonly entity = input.required<AccessRoleEnum>({ alias: 'acadvRequireRole' });
  readonly else = input<TemplateRef<void>>(undefined, { alias: 'acadvRequireRoleElse' });
  /** Optional additional boolean guard; when provided, access requires both the role and this condition. */
  readonly acadvRequireRoleAnd = input<boolean>();

  private user?: User;

  ngOnInit() {
    // The effect is created here, after Angular has applied input bindings, so reading
    // `this.entity()` (a required input) inside render() is safe. The injector option
    // allows effect() to be called outside the constructor injection context.
    effect(() => {
      this.acadvRequireRoleAnd();
      this.render();
    }, { injector: this.injector });

    this.authService.user$.pipe(untilDestroyed(this)).subscribe((user) => {
      if (user == undefined) {
        console.warn('acadvRequireRole requires an authenticated user');
        return;
      }
      this.user = user;
      this.render();
    });
  }

  render() {
    let hasAccess = this.user?.getAccessibleModules().find((a) => a.role == this.entity()) != undefined;

    const andCondition = this.acadvRequireRoleAnd();
    if (hasAccess && andCondition != undefined) {
      hasAccess = andCondition;
    }

    this.vcr.clear();

    if (!hasAccess) {
      this.else() && this.vcr.createEmbeddedView(this.else()!);
    } else {
      this.vcr.createEmbeddedView(this.templateRef);
    }
  }
}
